"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var ReleaseAddView_1 = __importDefault(require("./ReleaseAddView"));
var ReleaseListView_1 = __importDefault(require("./ReleaseListView"));
var ReleaseDetailView_1 = __importDefault(require("./ReleaseDetailView"));
var ReleasePage = react_1.default.memo(function () { return react_1.default.createElement(react_router_dom_1.Routes, null,
    react_1.default.createElement(react_router_dom_1.Route, { path: "add", element: react_1.default.createElement(ReleaseAddView_1.default, null) }),
    react_1.default.createElement(react_router_dom_1.Route, { path: "detail/:id", element: react_1.default.createElement(ReleaseDetailView_1.default, null) }),
    react_1.default.createElement(react_router_dom_1.Route, { path: "list", element: react_1.default.createElement(ReleaseListView_1.default, null) }),
    react_1.default.createElement(react_router_dom_1.Route, { path: "*", element: react_1.default.createElement(react_router_dom_1.Navigate, { to: "list", replace: true }) })); });
exports.default = ReleasePage;
